export default __webpack_public_path__ + "static/media/noti--white.04c38ae9.svg";